/**
 * Block is used on
 *
 * @returns {{postType: string, pagesMax: number, sort(*): void, loading: boolean, loadPosts(*=): void, activeIndex: null, search(): void, canShowMore: boolean, sortType: number, searchQuery: string, showMore(): void, page: number, results: [], open: boolean, selected: null}}
 */
export default () => ({
    results: [],
    loading: true,

    // Dropdown
    open: false,
    activeIndex: null,

    sortType: 3,
    selected: null,

    page: 1,
    pagesMax: 0,
    canShowMore: false,

    postType: 'care_home',
    searchQuery: '',

    clearSearch() {
        this.searchQuery = '';
        this.page = 1;
        this.results = [];
        this.loadPosts(false);
    },

    loadPosts(shouldScroll) {
        let ref = this;

        this.loading = true;

        fetch(hch_theme_ajax_endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            body: 'action=hch_fetch_carehomes_minimal&post_type=' + this.postType + '&page=' + this.page + '&query=' + this.searchQuery + '&sort=' + this.sortType
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                data.data.results.forEach(function (post, index) {
                    ref.results.push({
                        id: post.id,
                        title: post.title,
                        permalink: post.permalink,
                        post_type: post.post_type,
                        image: post.image,
                        image_alt: post.image_alt,
                        address: post.address,
                        telephone_one: post.telephone_one,
                        telephone_two: post.telephone_two,
                        featured_image_badge_enabled: post.featured_image_badge_enabled,
                        featured_image_badge_text: post.featured_image_badge_text,
                        tags: post.tags,
                        home_care_covering_text: post.home_care_covering_text
                    });
                });

                this.loading = false;
                this.page++;
                this.pagesMax = data.data.max_num_pages
                this.canShowMore = (this.pagesMax >= this.page);
            })
            .catch((error) => {
                console.error(error);
            });
    },

    sort(sortType) {
        this.page = 1;
        this.results = [];
        this.sortType = sortType;
        this.loadPosts(false);
    },

    search() {
        this.page = 1;
        this.results = [];
        this.loadPosts(false);
    },

    showMore() {
        this.loadPosts(true);
    }
})